import { Component } from '@angular/core';
import { PlotService } from '../../../services/plot.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'ebw-plot-map-snackbar',
  templateUrl: './plot-map-snackbar.component.html',
  styleUrls: ['./plot-map-snackbar.component.scss']
})
export class PlotMapSnackbarComponent {
  constructor(public plotService: PlotService) {}

  onConfirm() {
    this.plotService.acceptSelection();
  }

  onClose() {
    this.plotService.cancelSelection();
  }
}
